// extracted by mini-css-extract-plugin
export default {"faqPageContainer":"FAQPage_faqPageContainer__voxWL","questionSection":"FAQPage_questionSection__lIEYk"};